import Route from 'enum/route.enum';
import MenuId from 'enum/menu-id.enum';
import { translate as t } from 'utils/i18n';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';
import CastingManager from 'castingManager/CastingManager';
const menuList = [
  {
    id: MenuId.CAST,
    title: t('Cast.cast'),
    link: Route.route.Casting,
    description: t('Cast.cast_description'),
    icon: 'fa fa-plug',
    active: false,
    subTitle: [],
    image: require('../assets/images/menu/screen-cast.jpg'),
  },
  {
    id: MenuId.CHANNELS,
    title: t('Channels.channels'),
    link: Route.route.CHANNEL, // implement the logic here once done with configuration of selecting different template
    icon: 'fa fa-tv',
    active: false,
    subTitle: [],
    description: t('Channels.channels_description'),
    image: require('../assets/images/menu/tv.jpg'),
  },
  {
    id: MenuId.RADIO,
    title: t('Radio.radio'),
    link: Route.route.RADIO, // implement the logic here once done with configuration of selecting different template
    icon: 'fa fa-music',
    active: false,
    subTitle: [],
    description: t('Radio.radio_description'),
    image: require('../assets/images/menu/radio.jpg'),
  },
  // {
  //   id: MenuId.YOUTUBE,
  //   title: t('Youtube.youtube'),
  //   link: Route.route.Youtube,
  //   icon: 'fa fa-youtube',
  //   active: false,
  //   subTitle: [],
  // },
  // {
  //   id: 3,
  //   title: t("Netflix.netflix"),
  //   link: Route.route.Netflix,
  //   icon: "fa fa-film",
  //   active: false,
  //   subTitle: [

  //   ]
  // },
  //  {
  //     id: 4,
  //     title: t('PrimeVideo.primevideo'),
  //     link: Route.route.PrimeVideo,
  //     icon: 'fa fa-film',
  //     active: false,
  //     subTitle: [],
  //   },
  // {
  //   id: 4,
  //   title: t('Time.time'),
  //   link: Route.route.TIME,
  //   icon: 'fa fa-clock-o',
  //   active: false,
  //   subTitle: [],
  // },
  {
    id: MenuId.WEATHER,
    title: t('Weather.weather'),
    link: Route.route.WEATHER,
    icon: 'fa fa-cloud',
    active: false,
    subTitle: [],
    image: require('../assets/images/menu/weather.jpg'),
  },
  {
    id: MenuId.PORTAL,
    title: t('Portal.portal'),
    link: Route.route.PORTAL,
    icon: 'fa fa-hospital-o',
    active: false,
    subTitle: [],
    description: t('Portal.portal_description'),
  },
  {
    id: MenuId.NEWS,
    title: t('News.news'),
    link: Route.route.NEWS,
    icon: 'fa fa-newspaper-o',
    active: false,
    subTitle: [],
    image: require('../assets/images/menu/news.jpeg'),
  },

  // {
  //     id:6,
  //     title: MenuTitles.roomService,
  //     link: "",
  //     icon: "fa fa-bed",
  //     active: false,
  //     subTitle: [

  //     ]
  // },
  // {
  //     id:7,
  //     title: MenuTitles.hotelGuestInfo,
  //     link: "",
  //     icon: "fa fa-exclamation-circle",
  //     active: false,
  //     subTitle: [

  //     ]
  // },
  // {
  //   id: MenuId.INTERNET,
  //   title: t('Internet.internet'),
  //   link: Route.route.Internet, // implement the logic here once done with configuration of selecting different template
  //   icon: 'fa fa-globe',
  //   active: false,
  //   subTitle: [],
  // },

  {
    id: MenuId.SETTINGS,
    title: t('Settings.settings'),
    link: Route.route.SETTINGS, // implement the logic here once done with configuration of selecting different template
    icon: 'fa fa-cog',
    active: false,
    subTitle: [],
    image: require('../assets/images/menu/settings.jpg'),
  },
];

export const bottomNavigationItems = [
  { id: MenuId.SETTINGS, icon: 'fa fa-gear', link: Route.route.SETTINGS },
];

export const isRadioMenuAvailable = () => {
  return Boolean(Storages.MainStorage.getItem(StorageKeys.Keys.HASRADIOCHANNEL));
};

/**
 * Returns menuList with items that also appear in bottomNavigationItems removed.
 * Pass excludeBottomNav=true on layouts that render a separate BottomNavBar (e.g. Warwick)
 * so those items are not duplicated in the service-card list.
 */
export const getEffectiveMenuList = (excludeBottomNav = false) => {
  let items = menuList;

  if (CastingManager.getDevices().length === 0) {
    items = items.filter((item) => item.id !== MenuId.CAST);
  }

  if (!isRadioMenuAvailable()) {
    items = items.filter((item) => item.id !== MenuId.RADIO);
  }

  if (excludeBottomNav) {
    const bottomNavIds = new Set(bottomNavigationItems.map((item) => item.id));
    items = items.filter((item) => !bottomNavIds.has(item.id));
  }

  return items;
};

export default menuList;
